export default {
  CHAIRMAN_ID: 1,
  CHAIRMAN_NAME: 'Prezes zarządu',
  MEMBER_ID: 2,
  MEMBER_NAME: 'Członek zarządu',
  PROXY_ID: 3,
  PROXY_NAME: 'Prokurent',
  SUPERVISOR_ID: 4,
  SUPERVISOR_NAME: 'Członek rady nadzorczej',
};
